import React from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';

import Overall from '@/components/Overall/Overall'
import Login from '@/views/Login/Login'
import { menuConfig, isSubMenu, RouteItem } from '@/router/menuConfig';

/** 将配置展平为 RouteItem 列表 */
function flattenRoutes(config: typeof menuConfig): RouteItem[] {
  const result: RouteItem[] = [];
  for (const item of config) {
    if (isSubMenu(item)) {
      result.push(...item.children);
    } else {
      result.push(item);
    }
  }
  return result;
}

const flatRoutes = flattenRoutes(menuConfig);

interface IProps {
  // propsrouteList: any[]
}

interface IState {}

class Router extends React.Component<IProps, IState> {
  // 渲染Route组件
  renderRoute = () => {
    return (
      <Switch>
        {/* <Route path='/' exact render={() => <Redirect to='/labelCenter' />}></Route> */}
        <Route path="/" exact component={ Login }></Route>
        <Overall>
          <Switch>
            {flatRoutes.map(item => (
              <Route key={item.key} path={item.path} component={item.component}></Route>
            ))}
          </Switch>
        </Overall>
      </Switch>
    );
  }

  render() {
    return (
      <HashRouter>
        {
          this.renderRoute()
        }
      </HashRouter>
    );
  }
}
// 将redux中的路由信息导入致props
export default Router;
